import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';

// Components
import enviroments from './Services/enviroments';
import ProtectedRoute from './Components/Auth/ProtectedRoute';

// Views
import Navbar from './Components/Navbar/Navbar';
import Dashboard from './Views/Admin/Dashboard';
import Movil from './Views/Public/Movil';
import Login from './Views/Auth/Login';

const App = () => {
    let urlDemo = enviroments.urlBase;

    return (
        <BrowserRouter>
            <Routes>
                <Route path={`${urlDemo}/`} element={<Navbar> <Movil /> </Navbar>} />
                <Route path={`${urlDemo}/Admin/Dashboard`} exact element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                } />
                <Route path={`${urlDemo}/Login`} exact element={<Login />} />

                <Route path={`${urlDemo}/*`} element={<Navigate to={`${urlDemo}/`} replace />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App
